import { fetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';

type GetFilesByType = {
  corporationId: number;
  types: LegacyDocumentType[];
};

export const getFilesByType = async ({
  corporationId,
  types,
}: GetFilesByType) => {
  try {
    //add types to query params
    let queryParams = types.map((type) => `documentTypes=${type}`).join('&');
    //add corporationId to query params
    queryParams = `${queryParams}&corporationId=${corporationId}`;

    const res = await fetcher(`file/file-types/?${queryParams}`, {
      method: 'GET',
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error getting files by type', error);
    throw error;
  }
};
